import { uniqueId } from "lodash"
import SideNaveUserInfo from "../components/SideNaveUserInfo"
import SidenavItem from "../components/SidenavItem"
import SidenavProps from "../types/SidenavProps"

const SideNav = ( { items, userData, brandLogoUrl , bg_color,sideNavUserColor ,sideNavUserTextColor,  hoverColor,
    hoverText,textColor }:SidenavProps ) => {

    return (
        <div className={`h-full top-0 left-0 flex flex-col ${bg_color ? bg_color : 'bg-gray-900'} w-64`}>
            <div className="flex mx-auto ml-2">
                <img className="w-6/12" height="auto" src={ brandLogoUrl } alt="brand-logo" />
            </div>
            <div className="flex-1 ">
            {
                items?.map( item => (
                    <SidenavItem key={ uniqueId() } { ...item } bg_color={bg_color} hoverColor={hoverColor} hoverText={hoverText} textColor={textColor}/>
                ))
            }
            </div>
            {
                userData &&
                    <SideNaveUserInfo { ...userData }  sideNavUserTextColor={sideNavUserTextColor} sideNavUserColor={sideNavUserColor}/>
            }
        </div>
    )
}

export default SideNav
